import { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Lock } from "@phosphor-icons/react";

export default function CloseDayDialog({ warehouseName, entryCount, disabled, onConfirm }) {
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);

  const confirm = async () => {
    setClosing(true);
    try {
      await onConfirm();
      setOpen(false);
    } finally {
      setClosing(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <button
          data-testid="close-day-btn"
          disabled={disabled}
          className="inline-flex items-center gap-2 bg-red-500 hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-md font-semibold px-4 py-2 transition-colors duration-200"
        >
          <Lock size={18} weight="bold" />
          Close Day &amp; Lock Report
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="close-day-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">Close the day for {warehouseName}?</AlertDialogTitle>
          <AlertDialogDescription>
            This will finalize today's report with {entryCount}{" "}
            {entryCount === 1 ? "entry" : "entries"}. Once closed,{" "}
            <span className="font-semibold text-slate-900">no further changes can be made</span>{" "}
            and the report will be saved to the archives for the receiving team.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="close-day-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid="close-day-confirm"
            onClick={confirm}
            disabled={closing}
            className="bg-red-500 hover:bg-red-600 text-white"
          >
            {closing ? "Closing..." : "Yes, Close the Day"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
